import { render, staticRenderFns } from "./QrTransactionTable.vue?vue&type=template&id=7fb5fc00&"
import script from "./QrTransactionTable.vue?vue&type=script&lang=js&"
export * from "./QrTransactionTable.vue?vue&type=script&lang=js&"
import style0 from "./QrTransactionTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
